import { render, staticRenderFns } from "./OpenInAppConfirm.vue?vue&type=template&id=25f0ab5e&"
import script from "./OpenInAppConfirm.vue?vue&type=script&lang=ts&"
export * from "./OpenInAppConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports